import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import Content from 'main/Post/Content'

import LinkButton from 'shared/Button/LinkButton'

interface Datas {
  slug: string
  title: string
}

const s = {
  container: `w-full h-fit-content py-24 section`,
  wrapper: `wrapper`,

  flex: `flexbetween mb-16`,
  group: `w-fit-content h-fit-content`,
  title: `mb-0`,
  line: `w-full h-1.5 mt-0 bg-impred`,
  button: ``,
}

const Post = () => {
  const datas = useStaticQuery(graphql`
    query {
      allFlamelinkNavContent(filter: { slug: { regex: "/news/" } }) {
        nodes {
          slug
          title
        }
      }
      allFlamelinkPostContent(limit: 4, sort: { fields: date, order: DESC }) {
        nodes {
          id
          slug
          title
          date(formatString: "DD MMMM YYYY")
          snippet
          alt
          width
          height
          image {
            url
          }
        }
      }
    }
  `)

  const { slug, title } = datas.allFlamelinkNavContent.nodes[0] as Datas

  return (
    <section className={s.container} id={slug}>
      <div className={s.wrapper}>
        <div className={s.flex}>
          <div className={s.group}>
            <h2 className={s.title}>{title}</h2>
            <div className={s.line} />
          </div>

          <LinkButton to={`/posts/`} classname={s.button}>
            All Posts
          </LinkButton>
        </div>
        <Content datas={datas} />
      </div>
    </section>
  )
}

export default Post
